//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import Terms from './list';
import TermsEdit from './edit';
import TermsDelete from './delete';

export const FilterTerms = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[1] !== "terms") {
      setFilter({
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterTerms.Provider value={{ filter, setFilter }}>
      <Route path="/terms" exact component={Terms} isPrivate/>
      <Route path="/terms/add" exact component={TermsEdit} isPrivate/>
      <Route path="/terms/edit/:id" exact component={TermsEdit} isPrivate/>
      <Route path="/terms/delete/:id" exact component={TermsDelete} isPrivate/>
    </FilterTerms.Provider>
  )
}